import React from 'react'
import './onboarding.css'
import atixLogo from '../../../assets/logos/atix-logo.svg'
import { HeaderHLPure, SimpleFooterPure, SimpleLoading } from '../../pures'
import { Container, Grid } from '@material-ui/core'
import StepperPure from '../../pures/stepper/stepper.pure'
import { useTranslation } from 'react-i18next';

function OnboardingView(props) {
    const {
        stepsStepper,
        currentStep,
        stepsContent
    } = props;
    const { i18n } = useTranslation();

    const StepComponent = stepsContent[currentStep].component

    const changeLanguage = (e) => {
        if (e.target.checked) {
            i18n.changeLanguage('es-MX');
        } else {
            i18n.changeLanguage('en');
        }
    }

    if (props.loading) return <div className="loading">
        <SimpleLoading />
    </div>

    return (
        <div className='onboardingView-container'>
            <div className="onboardingView-header">
                <Container style={{ height: '100%' }}>
                    <img alt='Logo de atix' className='onboardingView-logo' src={atixLogo} style={{ height: '36px', marginTop: '9px' }} />
                    <label className="loginView-language" htmlFor="language-switch">
                        <input id='language-switch' className='loginView-language-checkbox' type="checkbox" value={i18n.language === 'es-MX'} onClick={changeLanguage} />
                        <span class="k-icon k-font-icon k-i-globe-outline"></span>
                        <span className={i18n.language === 'en' ? 'loginView-language-selected' : ''}>EN</span> | <span className={i18n.language === 'es-MX' ? 'loginView-language-selected' : ''}>ES</span>
                    </label>
                </Container>
            </div>
            <div className='onboardingView-content'>
                <Container>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <HeaderHLPure title="Onboarding" />
                        </Grid>
                        <Grid item xs={12}>
                            <StepperPure
                                value={currentStep}
                                // onChange={(e) => moveStep(e.value)}
                                items={stepsStepper}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Container maxWidth={false} className='onboardingView-step-content'>
                                <StepComponent {...props} />
                            </Container>
                        </Grid>
                    </Grid>
                </Container>
            </div>
            <div className="onboardingView-footer">
                <SimpleFooterPure />
            </div>
        </div>
    )
}

export default OnboardingView